import ReactApexChart from 'react-apexcharts'
import './styles.css';

const DonutChart = (props) => {

  const series = props.isStatusChart ? [8, 22, 9] : [18, 22];
  const colors = props.isStatusChart ? ['#009B2A', '#3C8C9E', '#F09837'] : ['#009B2A', '#F09837'];
  const textColor = props.isStatusChart ? ['#000000', '#ffffff', '#ffffff'] : ['#000000', '#ffffff'];
  const labels = props.isStatusChart ? ['Open', 'In Progress', 'Closed'] : ['Executed', 'Submitted']

  const options = {
    chart: {
      width: '100%',
      type: 'donut',
    },
    fill: {
      colors: colors
    },
    labels: labels,
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: '68%',
          labels: {
            show: true,
            value: {
              show: true,
              offsetY: -4,
              showAlways: true,
              fontWeight: 600,
              fontSize: '12px',
              color: '#000000'
            },
            total: {
              show: true,

              showAlways: true,
              label: 'Total Jobs',
              fontSize: '10px',
              color: '#000000'
            },

          }
        }
      }
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '6px',
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontWeight: 'bold',
        colors: textColor
      },
      formatter: function (val) {
        let value = Math.round(val)
        return value + '%'
      },
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        }
      },
      hover: {
        filter: {
          type: 'none',
        }
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
        }
      },
    },
    legend: {
      show: false,
      position: 'right',
      offsetX: 0,
      height: 230,

    },
    tooltip: {
      enabled: true,
      theme: false,
      fillSeriesColor: false,
      marker: {
        show: false,
      },
      onDatasetHover: {
        highlightDataSeries: false,
      },
    }
  }

  return (
    <div id='chart' style={{ marginLeft: '-85px', marginRight: '-50px' }}>
      <ReactApexChart options={options} series={series} type="donut" height='85%' width='85%' />
    </div>
  );
}


export default DonutChart 